import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentRelease } from "../shared/data.service";
import { ReleaseScheduleInsertRequest } from "../shared/ReleaseScheduleInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-add-release",
	templateUrl: "./student-add-release.component.html",
	styleUrls: ["./student-add-release.component.css"],
})
export class StudentAddReleaseComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentReleaseService: DataService_StudentRelease
	) {}

	ngOnInit(): void {
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.user = this.dialogConfig.data.user;

		this.loadReleaseType();
		this.loadExcuse();

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	SelectedPerson: any;
	user: any;

	StudentID: any;
	StudentName: any;

	ReleaseTypeID: any;
	lstReleaseType: any = [];

	AdmitTime: Date = new Date();
	ReleaseTime: Date = new Date();
	StartDate: Date = new Date();
	EndDate: Date = new Date();

	OnlyShowPresent: any = false;

	Excuse: any;
	lstAllExcuse: any = [];
	lstExcuse: any = [];

	Comment: any = "";

	MonCheck: any = false;
	TueCheck: any = false;
	WedCheck: any = false;
	ThuCheck: any = false;
	FriCheck: any = false;
	SatCheck: any = false;
	SunCheck: any = false;

	lstGuardian: any = [];

	errorMessage: any = "";

	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////
	loadReleaseType() {
		var result = this.StudentReleaseService.ReleaseTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstReleaseType = response;

				this.ReleaseTypeID = this.lstReleaseType[0].ReleaseTypeID;
			},
			(error) => {}
		);
	}

	loadExcuse() {
		var result = this.StudentReleaseService.ExcuseSelectList(this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAllExcuse = response;

				if (this.OnlyShowPresent == true) {
					this.lstExcuse = this.lstAllExcuse.filter((excuse) => excuse.IsCountAsPresent == 1);
				} else {
					this.lstExcuse = this.lstAllExcuse;
				}

				this.Excuse = this.lstExcuse[0];
			},
			(error) => {}
		);
	}
	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");
		var fATime = moment(this.AdmitTime).format("HH:mm") + ":00";
		var fRTime = moment(this.ReleaseTime).format("HH:mm") + ":00";

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Start Date Invalid";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "End Date Invalid";
			return;
		}
		if (String(fATime).toLowerCase().indexOf("invalid") != -1 && this.EnableAdmitTime() == true) {
			this.errorMessage = "Admit Time Invalid";
			return;
		}
		if (String(fRTime).toLowerCase().indexOf("invalid") != -1 && this.EnableReleaseTime() == true) {
			this.errorMessage = "Release Time Invalid";
			return;
		}

		if (this.EnableAdmitTime() == true && this.EnableReleaseTime() == true && this.AdmitTime >= this.ReleaseTime) {
			this.errorMessage = "Admit Time cannot be >= Release Time";
			return;
		}

		//Call SP

		if (this.EnableAdmitTime() == false) {
			fATime = "NULL";
		}
		if (this.EnableReleaseTime() == false) {
			fRTime = "NULL";
		}

		let parms: ReleaseScheduleInsertRequest = {
			ReleaseTypeID: this.ReleaseTypeID,
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			GroupActionID: -1, //Group Action
			ExcuseID: this.Excuse.ExcuseID,
			StartDate: fsDate,
			EndDate: feDate,
			AdmitTime: fATime,
			ReleaseTime: fRTime,
			Comment: this.Comment,
			DaySun: this.SunCheck == true ? 1 : 0,
			DayMon: this.MonCheck == true ? 1 : 0,
			DayTue: this.TueCheck == true ? 1 : 0,
			DayWed: this.WedCheck == true ? 1 : 0,
			DayThu: this.ThuCheck == true ? 1 : 0,
			DayFri: this.FriCheck == true ? 1 : 0,
			DaySat: this.SatCheck == true ? 1 : 0,
		};

		var result = this.StudentReleaseService.ReleaseScheduleInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Release was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Release",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////

	////////////////////////////////////
	// Events
	////////////////////////////////////
	onShowPresentChange(val) {
		this.OnlyShowPresent = val;

		if (this.OnlyShowPresent == true) {
			this.lstExcuse = this.lstAllExcuse.filter((excuse) => excuse.IsCountAsPresent == 1);

			if (this.Excuse.IsCountAsPresent != 1) {
				this.Excuse = this.lstExcuse[0];
			}
		} else {
			this.lstExcuse = this.lstAllExcuse;
			// this.Excuse = this.lstExcuse[0];
		}
	}
	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////
	EnableAdmitTime() {
		//Late Arrival
		if (this.ReleaseTypeID == 1) {
			return true;
		}
		//Mid Day
		else if (this.ReleaseTypeID == 2) {
			return true;
		}
		//Early Release
		else if (this.ReleaseTypeID == 3) {
			return false;
		}
		//Full Day Release
		else if (this.ReleaseTypeID == 4) {
			return false;
		} else {
			return false;
		}
	}

	EnableReleaseTime() {
		//Late Arrival
		if (this.ReleaseTypeID == 1) {
			return false;
		}
		//Mid Day
		else if (this.ReleaseTypeID == 2) {
			return true;
		}
		//Early Release
		else if (this.ReleaseTypeID == 3) {
			return true;
		}
		//Full Day Release
		else if (this.ReleaseTypeID == 4) {
			return false;
		} else {
			return false;
		}
	}

	////////////////////////////////////
}
